import { QueryClient, QueryClientProvider } from 'react-query';
import Routes from 'routes/Routes';
import { configureFakeBackend } from 'helpers';
import 'assets/scss/Saas.scss';
import ReactGA from 'react-ga';

ReactGA.initialize('G-DTZXQ1XXF4');

const queryClient = new QueryClient();

const App = () => {
    configureFakeBackend();

    return (
        <QueryClientProvider client={queryClient}>
            <Routes />
        </QueryClientProvider>
    );
};

export default App;
